import type { RouteRecordRaw } from "vue-router"

const routes: RouteRecordRaw[] = [
  {
    name: "test.case.load",
    path: "/test/cases/:id",
    component: () => import("@/views/test/TestCaseLoadView.vue"),
  },
]

export default routes
